// Units of measure ride on the rows, not on the column contract: an All
// Locations view can span a metric and an imperial plant, so a column's unit is
// a per-row value. ClickHouse stores the plain-ASCII form, which is what the
// CSV exports keep; only rendered surfaces get the typographic one.

const UNIT_SYMBOLS: Record<string, string> = {
  cm2: "cm²",
  in2: "in²",
};

/** Rendering form of a stored unit. Unknown values pass through unchanged. */
export const toUnitSymbol = (value: unknown): string | undefined => {
  if (typeof value !== "string") return undefined;

  const trimmed = value.trim();
  if (trimmed === "") return undefined;

  return UNIT_SYMBOLS[trimmed] ?? trimmed;
};

/**
 * Every distinct unit the rows carry, rows without one ignored. The count is
 * the decision: none leaves the column alone, one belongs in the header, more
 * than one has to go into each cell because no header can say which row is
 * which.
 */
export const collectUnitSymbols = (
  rows: readonly Record<string, unknown>[],
  unitsName: string | undefined,
): string[] => {
  if (unitsName === undefined) return [];

  const symbols = new Set<string>();
  for (const row of rows) {
    const symbol = toUnitSymbol(row[unitsName]);
    if (symbol !== undefined) symbols.add(symbol);
  }

  return [...symbols];
};

/** `Rib Eye Area (cm²)`, or the bare label when there is no unit to add. */
export const withUnitSuffix = (
  label: string,
  symbol: string | undefined,
): string => (symbol === undefined ? label : `${label} (${symbol})`);
